const CHANGE_APP_HOSTNAMES: Array<string | RegExp> = [
	// production and staging
	'www.change.org',
	'www.staging-change.org',
	// demo envs: a single DNS label, so `assets.demo.changeeng.org` and `www.a.b.changeeng.org` fail
	/^www\.[a-z0-9-]+\.changeeng\.org$/,
	// PR previews
	/^(preview-)?corgi-\d+\.preview(-staging)?\.changeeng\.org$/,
	// Tailscale previews
	/^preview-corgi-\d+\.ojos-alligator\.ts\.net$/,
	// local dev
	'www.local-change.org',
];

/**
 * Whether `hostname` is a host where the platform's pages are served. Upload, content and
 * wildcard `*.change.org` hosts are deliberately not included.
 *
 * Keep in sync with `detectEnvironment` and the front-end `proxy-envs`.
 */
export function isChangeAppHostname(hostname: string): boolean {
	return CHANGE_APP_HOSTNAMES.some((entry) => (typeof entry === 'string' ? entry === hostname : entry.test(hostname)));
}
